// Internal: Regular expression for emails. Reference: https://emailregex.com
const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// Public: Checks if a string is a potentially valid email address.
export function isEmail (val?: string): val is string {
  return emailRegexp.test(String(val))
}
